import * as ACT from './actions';

export const addOrder = order => ({
    type: ACT.ADD_ORDER,
    order: order
});

export const updateOrder = order => ({
    type: ACT.UPDATE_ORDER,
    order: order
});

export const removeOrder = name => ({
    type: ACT.REMOVE_ORDER,
    name: name
});


// WEBPACK FOOTER //
// ./src/app/actions/changeOrders.js